<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
    <mat-tab label="INVOICE"><pdf-document-viewer></pdf-document-viewer> </mat-tab>
    <mat-tab label="EMAIL">
        <invoice-email [emailBody]="expenseEmailBody"></invoice-email>
    </mat-tab>
</mat-tab-group>
